module.exports = __webpack_public_path__ + "img/biaozhi1.051b7b1c.png";